import { useRef, useEffect } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';
import PieChartIcon from '../../../../assets/icons/common/PieChartIcon';

import styles from './styles.module.scss';

const Index = ({ id, data = 0.95, color = '#208EF3', text = '' }) => {
  const windowSize = useWindowSize();
  let baseSize = 140;
  let size = baseSize;
  let strokeWidth = '12px';
  if (windowSize?.width <= 374) {
    size = 88;
    strokeWidth = '8px';
  } else if (windowSize?.width <= 768) {
    size = 112;
  } else if (windowSize?.width <= 850) {
    size = 120;
  }

  const ref = useRef();
  const ceilData = parseFloat((data * 100).toFixed(2));
  const radius = (size - 25) / 2;
  const point = size / 2;
  const perimeter = 2 * radius * Math.PI;

  useEffect(() => {
    if (!data && !ref.current) {
      return;
    }

    ref.current.style.strokeDashoffset = ((100 - ceilData) / 100) * perimeter;
  });

  return (
    <div className={styles.wrapper}>
      <PieChartIcon
        size={size}
        styles={styles}
        point={point}
        radius={radius}
        perimeter={perimeter}
        strokeWidth={strokeWidth}
        refObj={ref}
        id={id}
        ceilData={ceilData}
      />
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default Index;
